import { makeStyles } from '@material-ui/core/styles';
import AssistantIcon from '@material-ui/icons/Assistant';
import { CustomBreadcrumbs } from 'candy-commons-components';
import React from 'react';
import { Edit, SimpleForm, useNotify, useTranslate } from 'react-admin';
import CustomToolbar from '../../components/CustomToolbar';
import NewFeaturesBannerFields, {
    prepareBannerFormData,
} from './NewFeaturesBannerFields';

const NewFeaturesBannerEdit = ({ permissions = {}, ...props }) => {
    const classes = useStyles();
    const { id } = props;
    const translation = useTranslate();
    const notify = useNotify();
    const isEditDisabled = !permissions?.['new-features-banner']?.update;
    const breadcrumbsData = [
        {
            text: translation('resources.new-features-banner.name'),
            url: 'new-features-banner',
            icon: <AssistantIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];
    const handleSaveError = (error) => {
        const message = typeof error === 'string' ? error : error?.message;
        notify(message || 'ra.notification.http_error', { type: 'warning' });
    };
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit
                className={classes.reverseButtonSave}
                {...props}
                transform={prepareBannerFormData}
                mutationMode="pessimistic"
                onFailure={handleSaveError}
            >
                <SimpleForm
                    toolbar={
                        <CustomToolbar
                            permissions={permissions}
                            isEditDisabled={isEditDisabled}
                        />
                    }
                >
                    <NewFeaturesBannerFields disabled={isEditDisabled} />
                </SimpleForm>
            </Edit>
        </>
    );
};
const useStyles = makeStyles({
    reverseButtonSave: {
        '& .MuiToolbar-root>div': {
            flexDirection: 'row-reverse',
        },
    },
});
export default NewFeaturesBannerEdit;
